<h1>CORSI</h1>
<h2>De Cifris ModCrypto</h2>
<br>
<p>
    De Cifris ModCrypto è il corso residenziale di crittografia organizzato dall'Associazione De Cifris,
    rivolto a soci con un background matematico di base: studenti magistrali, dottorandi e professionisti
    del settore. L'obiettivo del corso è fornire una preparazione completa e pratica nella crittografia moderna,
    dai fondamenti classici alle tecniche avanzate e post-quantistiche.
    Le lezioni si tengono in presenza a Roma, con sessioni frontali al mattino e sessioni
    sperimentali al pomeriggio, condotte da esperti del panorama crittografico italiano.
    Il corso è strutturato in due moduli indipendenti:
</p>
<ul>
    <li><b>Introduzione alla Crittografia Moderna</b></li>
    <li><b>Crittografia Avanzata</b></li>
</ul>
<p>
    La partecipazione a uno o entrambi i moduli dà diritto al rilascio di un attestato
    di partecipazione.
</p>
<h3>EDIZIONI 2026</h3>
<ul>
    <li><a routerLink="/attivita/modcrypto26">Crittografia Moderna 2026</a>
    </li>
</ul>
<br>

<h2>De Cifris Trends</h2>
<br>
<p>
    Corsi online internazionali con un'anima italiana.
</p>
<p>
    La ricca attività di ricerca svolta all’interno della comunità crittografica Italiana, sia nel campo
    accademico, sia nel mondo del lavoro e dell'impresa, si completa di corsi online, rivolti ad una platea
    internazionale e tenuti principalmente da esperti italiani.
</p>
<p>
    Questi corsi sono utili a chiunque abbia familiarità con la crittografia standard e il suo background
    matematico, tra cui: dottorandi, laureati , professionisti che lavorano per aziende o settore pubblico.
    Questi corsi sono anche pensati come utile approfondimento per studenti di laurea magistrale con speciale
    interesse per la crittografia.
</p>
<p>
    Questi corsi si tengono in due modalità:
</p>
<ul>
    <li> Prima fruizione: il corso viene tenuto in diretta (le lezioni vengono man mano registrate). Alcuni
        assistenti sono a disposizione online per chiarimenti.
        Il corso si conclude con un esame (che dà un certificato).
    </li>
    <li> Seconda fruizione: gli studenti accedono alle lezioni registrate (durante la prima fruizione). Alcuni
        assistenti sono a disposizione online per chiarimenti per tutto il periodo.
        Il corso si conclude con un esame (che dà un certificato).</li>
</ul>
<h3>EDIZIONI 2025</h3>
<ul>
    <li><a routerLink="/attivita/trends25">Introduction to cryptography and its applications</a>
    </li>
</ul>
<h3>EDIZIONI 2024</h3>
<ul>
    <li><a routerLink="/attivita/trends24">The French Magisterium</a>
    </li>
</ul>
<h3>EDIZIONI 2023</h3>
<ul>
    <li><a routerLink="/attivita/trends23">Trends in Cryptographic Protocols</a>
    </li>
    <li><a routerLink="/attivita/trends22bis">Post Quantum and
            Cloud Cryptography (seconda fruizione)</a></li>
</ul>
<h3>EDIZIONI 2022</h3>
<ul>
    <li><a routerLink="/attivita/trends22">Post Quantum and
            Cloud Cryptography</a></li>

</ul>
<h2>De Cifris Young to Young</h2>
<p>
    De Cifris Y2Y : Young to Young (da giovani a giovani). Il corso è tenuto da giovani docenti ed è
    rivolto a un pubblico di giovani (e non solo) interessati alla crittografia, neolaureati, dottorandi
    in materia, dipendenti di aziende del settore, liberi professionisti,... <br><br>
    I corsi sono di introduzione alla crittografia, con esempi e applicazioni.
</p>
<h3>EDIZIONI 2023</h3>
<ul>
    <li><a routerLink="/attivita/y2y-blockchain">Edizione 2023</a> (De Cifris Y2Y in Blockchain
        e Smart Contract)</li>
</ul>